export const REPORT_TYPE_AD_ACCOUNT_NOT_MONITORED = "AD_ACCOUNT_NOT_MONITORED";

export const REPORTS_DATA = {
    [REPORT_TYPE_AD_ACCOUNT_NOT_MONITORED]: {
        "title": {
            "spanish": "Todas las mañanas se envía un reporte con las cuentas publicitarias sin monitoreo",
            "english": "Every morning a report is sent with unmonitored advertising accounts"
        }
    }
};

// Utility function to get localized text based on current language
export const getLocalizedText = (data, language = 'es', key = 'spanish') => {
    if (!data) return '';
    
    // Map language codes to dictionary keys
    const languageMap = {
        'es': 'spanish',
        'en': 'english'
    };
    
    const languageKey = languageMap[language] || 'spanish';
    return data[languageKey] || data['spanish'] || '';
};

// Utility function to get localized report title
export const getLocalizedReportTitle = (reportType, language = 'es') => {
    if (!REPORTS_DATA[reportType] || !REPORTS_DATA[reportType].title) return '';
    
    return getLocalizedText(REPORTS_DATA[reportType].title, language);
};

/*
Usage Example in a React component:

import { REPORTS_DATA, getLocalizedText, getLocalizedReportTitle } from '../reports';
import { withTranslation } from 'react-i18next';

class MyComponent extends Component {
    render() {
        const { i18n } = this.props;
        const reportType = 'AD_ACCOUNT_NOT_MONITORED';
        
        // Get report title using utility function
        const reportTitle = getLocalizedReportTitle(reportType, i18n.language);
        
        // Or get title manually
        const manualTitle = getLocalizedText(REPORTS_DATA[reportType].title, i18n.language);
        
        return (
            <div>
                <h3>{reportTitle}</h3>
                <p>{manualTitle}</p>
            </div>
        );
    }
}

export default withTranslation()(MyComponent);
*/
